/**
 * Catálogo canónico de provincias argentinas para el frontend de Retinar.
 * Fuente única compartida por PatientDataForm, PhaseOne, InstitutionsManagement e InstitutionNodes.
 *
 * RB-1: Un solo catálogo para todo el frontend.
 * RB-2: Orden y etiquetas funcionales preservadas de los formularios de pacientes.
 * RB-3: Opciones aptas para select con { value, label }.
 */

export const provinceOptions = [
  { value: 'Buenos Aires', label: 'Buenos Aires' },
  { value: 'CABA', label: 'CABA' },
  { value: 'Catamarca', label: 'Catamarca' },
  { value: 'Chaco', label: 'Chaco' },
  { value: 'Chubut', label: 'Chubut' },
  { value: 'Córdoba', label: 'Córdoba' },
  { value: 'Corrientes', label: 'Corrientes' },
  { value: 'Entre Ríos', label: 'Entre Ríos' },
  { value: 'Formosa', label: 'Formosa' },
  { value: 'Jujuy', label: 'Jujuy' },
  { value: 'La Pampa', label: 'La Pampa' },
  { value: 'La Rioja', label: 'La Rioja' },
  { value: 'Mendoza', label: 'Mendoza' },
  { value: 'Misiones', label: 'Misiones' },
  { value: 'Neuquén', label: 'Neuquén' },
  { value: 'Río Negro', label: 'Río Negro' },
  { value: 'Salta', label: 'Salta' },
  { value: 'San Juan', label: 'San Juan' },
  { value: 'San Luis', label: 'San Luis' },
  { value: 'Santa Cruz', label: 'Santa Cruz' },
  { value: 'Santa Fe', label: 'Santa Fe' },
  { value: 'Santiago del Estero', label: 'Santiago del Estero' },
  { value: 'Tierra del Fuego', label: 'Tierra del Fuego' },
  { value: 'Tucumán', label: 'Tucumán' }
]

/**
 * Devuelve las opciones del catálogo base listas para un select.
 * Si currentValue no está en el catálogo y es un string no vacío,
 * agrega una opción visible de legacy para que el usuario pueda verla
 * y decidir si la regulariza o la conserva.
 *
 * RB-4: El helper no muta el catálogo base ni genera duplicados.
 *
 * @param {string} [currentValue] - Valor actual del campo provincia (puede ser legacy).
 * @returns {{ value: string, label: string }[]}
 */
export function buildProvinceSelectOptions (currentValue) {
  const baseValues = provinceOptions.map((opt) => opt.value)
  const isLegacy = currentValue && typeof currentValue === 'string' &&
    currentValue.trim() !== '' &&
    !baseValues.includes(currentValue)

  if (isLegacy) {
    return [
      ...provinceOptions,
      { value: currentValue, label: `Provincia histórica: ${currentValue}` }
    ]
  }

  return provinceOptions
}
